import { ChevronDown, Pencil, UserRound } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { ProjectPlan, ProjectPlanCopy } from '@/frontend/features/Fde/projectPlanTypes'

export default function ProjectPlanBrief({ plan, copy, canManage, onEdit }: {
  plan: ProjectPlan; copy: ProjectPlanCopy; canManage: boolean; onEdit: () => void
}) {
  const lead = plan.members.find((member) => member.id === plan.lead_member_id)
  return <section aria-label={copy.direction} className="rounded-lg border border-border bg-background">
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
      <div className="flex flex-wrap items-center gap-4 text-xs">
        <span title={plan.health_reason || undefined} className={cn('inline-flex items-center gap-2 font-medium',
          plan.health === 'on_track' ? 'text-emerald-600' : plan.health === 'at_risk' ? 'text-amber-700 dark:text-amber-400' : 'text-muted-foreground')}>
          <span className={cn('size-1.5 rounded-full', plan.health === 'on_track' ? 'bg-emerald-500' : plan.health === 'at_risk' ? 'bg-amber-500' : 'bg-muted-foreground')} />
          {plan.health ? copy.health_states[plan.health] : copy.health_unknown}
        </span>
        {lead && <span title={copy.lead} className="inline-flex items-center gap-1.5 text-muted-foreground"><UserRound className="size-3.5" />{lead.name}</span>}
      </div>
      {canManage && <Button variant="ghost" size="sm" className="h-7 gap-1.5 px-2 text-xs text-muted-foreground" onClick={onEdit}><Pencil className="size-3" />{plan.scope || plan.success_criteria ? copy.edit_direction : copy.setup}</Button>}
    </div>
    {plan.scope || plan.success_criteria ? <details className="group border-t border-border/60">
      <summary className="flex cursor-pointer list-none items-center justify-between px-4 py-2.5 text-xs text-muted-foreground hover:text-foreground [&::-webkit-details-marker]:hidden">
        {copy.direction}<ChevronDown className="size-3.5 transition-transform group-open:rotate-180" />
      </summary>
      <dl className="grid gap-5 px-4 pb-4 sm:grid-cols-2">
        {plan.scope && <div><dt className="text-[11px] text-muted-foreground">{copy.scope}</dt><dd className="mt-1.5 whitespace-pre-line text-sm leading-6">{plan.scope}</dd></div>}
        {plan.success_criteria && <div><dt className="text-[11px] text-muted-foreground">{copy.success_criteria}</dt><dd className="mt-1.5 whitespace-pre-line text-sm leading-6">{plan.success_criteria}</dd></div>}
      </dl>
    </details> : <p className="px-4 pb-3 text-xs text-muted-foreground">{copy.setup_hint}</p>}
  </section>
}
